import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

const EditSessionModal = ({ isOpen, onClose, session, onSave, cities }) => {
  const { t, i18n } = useTranslation();
  const [editedSession, setEditedSession] = useState(null);

  const sessionTypes = ["Session Adulte (26 ans et plus)", "Session Jeune (18 à 25 ans)", "Session Libre (tout âge)"];

  useEffect(() => {
    if (session) {
      const formatDate = (dateString) => {
        if (!dateString) return '';
        const d = new Date(dateString);
        const year = d.getFullYear();
        const month = String(d.getMonth() + 1).padStart(2, '0');
        const day = String(d.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
      };

      const formatTime = (dateString) => {
        if (!dateString) return '';
        const d = new Date(dateString);
        const hours = String(d.getHours()).padStart(2, '0');
        const minutes = String(d.getMinutes()).padStart(2, '0');
        return `${hours}:${minutes}`;
      };

      setEditedSession({
        ...session,
        date: formatDate(session.startTime),
        startTime: formatTime(session.startTime),
        endTime: formatTime(session.endTime),
      });
    } else {
      setEditedSession(null);
    }
  }, [session]);

  if (!isOpen || !editedSession) return null;

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setEditedSession(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSave = () => {
    // Validate date, startTime and endTime before saving
    if (!editedSession.date || !editedSession.startTime || !editedSession.endTime) {
      alert(t('editSession.missingDates')); // You might want a better alert here
      return;
    }

    // Combine date and time to form full ISO strings for backend
    const startDateTime = new Date(`${editedSession.date}T${editedSession.startTime}:00`);
    const endDateTime = new Date(`${editedSession.date}T${editedSession.endTime}:00`);

    const sessionToSave = {
      ...editedSession,
      startTime: startDateTime.toISOString(), // Convert to ISO string (UTC)
      endTime: endDateTime.toISOString(),     // Convert to ISO string (UTC)
    };
    delete sessionToSave.date; // Remove frontend-only property

    onSave(sessionToSave);
    onClose();
  };

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <h2>{t('editSession.title')}</h2>
        <form onSubmit={(e) => { e.preventDefault(); handleSave(); }}>
          <div className="form-group">
            <label>{t('editSession.sessionType')}:</label>
            <select name="title" value={editedSession.title} onChange={handleInputChange} required>
              {sessionTypes.map(type => <option key={type} value={type}>{type}</option>)}
            </select>
          </div>
          <div className="form-group">
            <label>{t('editSession.city')}:</label>
            <select name="cityId" value={editedSession.cityId} onChange={handleInputChange} required>
              <option value="" disabled>Sélectionner une ville</option>
              {cities.map(c => <option key={c.id} value={c.id}>{c.name[i18n.language.split('-')[0]]}</option>)}
            </select>
          </div>
          <div className="form-group">
            <label>{t('editSession.address')}:</label>
            <input type="text" name="address" value={editedSession.address} onChange={handleInputChange} required />
          </div>
          <div className="form-group">
            <label>{t('editSession.language')}:</label>
            <select name="language" value={editedSession.language} onChange={handleInputChange}>
              <option value="Français">Français</option>
              <option value="Anglais">Anglais</option>
              <option value="Bilingue">Bilingue</option>
            </select>
          </div>
          <div className="form-group">
            <label>Date:</label>
            <input type="date" name="date" value={editedSession.date} onChange={handleInputChange} required />
          </div>
          <div className="form-group">
            <label>Heure de Début:</label>
            <input type="time" name="startTime" value={editedSession.startTime} onChange={handleInputChange} required />
          </div>
          <div className="form-group">
            <label>Heure de Fin:</label>
            <input type="time" name="endTime" value={editedSession.endTime} onChange={handleInputChange} required />
          </div>
          
          <div className="modal-actions">
            <button type="submit">{t('editSession.save')}</button>
            <button type="button" onClick={onClose}>{t('editSession.cancel')}</button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default EditSessionModal;